<template>
  <Transition
    :enter-active-class="enter"
    :enter-from-class="enterFrom"
    :enter-to-class="enterTo"
    :leave-active-class="leave"
    :leave-from-class="leaveFrom"
    :leave-to-class="leaveTo"
    @before-enter="onBeforeEnter"
    @after-leave="onAfterLeave"
  >
    <slot />
  </Transition>
</template>

<script setup lang="ts">
import { inject } from 'vue'
import type { TransitionApi } from '../Root/transitionApi'
import type { Props } from './props'

defineProps<Props>()

const api = inject('TransitionApi') as TransitionApi

function onBeforeEnter(): void {
  api.setShowTransitionValue(true)
}

function onAfterLeave(): void {
  api.setShowTransitionValue(false)
}
</script>
